import * as Yup from 'yup';

export function onlyTransferContactValidator() {
  return Yup.object().shape({
    department_id: Yup.string().required('Informe o departamento.')
  });
}

